import { log } from 'log';
import { range as ramdaRange } from 'ramda';

import * as constants from './constants';

export const getDaysOfMonth = ({ year, month }) => {
    const date = year && (month || month === 0)
        ? new Date(year, Number(month) + 1, 0)
        : new Date(1970, 1, 0);

    const monthDays = date.getDate();
    return ramdaRange(1, monthDays + 1);
};

export const parse = (value) => {
    let { day } = value;
    const days = getDaysOfMonth(value);
    day = days.includes(day) ? day : days[days.length - 1];

    return getTimestamp({ ...value, day });
};

export const fromTimestamp = (ts) => {
    const date = new Date(ts);

    return {
        year: date.getFullYear(),
        month: date.getMonth(),
        day: date.getDate()
    };
};

export const convertPickerToISO = ({ year, month, day }) => {
    const yyyy = year || '';
    const mm = month || month === 0 ? (Number(month) + 1).toString().padStart(2, '0') : '';
    const dd = day ? day.toString().padStart(2, '0') : '';

    return [yyyy, mm, dd].join('-');
};

export const convertISOToPicker = (value) => {
    const [year = '', month = '', day = ''] = value?.split('-') || [];

    return {
        year: year === '' ? year : Number(year),
        month: month === '' ? month : Number(month) - 1,
        day: day === '' ? day : Number(day)
    };
};

export const getTimestamp = ({ year, month, day }) => new Date(year, month, day).valueOf();

export const getYears = (range) => {
    const rangeRegex = /^(\d{4})-(\d{4})$/;

    if (range === constants.RANGE.PAST) {
        return getPastYears();
    }

    if (range === constants.RANGE.FUTURE) {
        return getFutureYears();
    }

    if (rangeRegex.test(range)) {
        const match = rangeRegex.exec(range);
        const from = Number(match[1]);
        const to = Number(match[2]);

        if (Math.abs(to - from) > 100) {
            log('error', 'Incorrect DatePicker range prop (more than 100 years)');

            return getPastYears();
        }

        return getCustomRangeYears(from, to);
    }

    return getPastYears();
};

export const getPastYears = () => {
    const date = new Date();
    const lifeSpan = 100;
    const year = date.getFullYear();
    const years = ramdaRange(year - lifeSpan, year + 1);

    return years.reverse().map(y => ({ value: y }));
};

export const getFutureYears = () => {
    const date = new Date();
    const year = date.getFullYear();
    const futureYears = ramdaRange(year, year + 11);

    return futureYears.map(y => ({ value: y }));
};

export const getCustomRangeYears = (from, to) => {
    const years = from > to ? ramdaRange(to, from + 1) : ramdaRange(from, to + 1).reverse();

    return years.map(y => ({ value: y }));
};

export const pickerStates = {
    [constants.PICKERS.day]: ({ value, translate }) => ({
        value: value.day && Number(value.day),
        placeholder: translate('day'),
        options: getDaysOfMonth(value).map(d => ({ value: d }))
    }),
    [constants.PICKERS.month]: ({ value, translate }) => ({
        value: value.month,
        placeholder: translate('month'),
        options: ramdaRange(0, 12).map(month => ({ value: month, label: translate(`month.${constants.MONTHS[month]}`) }))
    }),
    [constants.PICKERS.year]: ({ value, translate, range }) => {
        const options = getYears(range);

        return {
            value: value.year,
            placeholder: translate('year'),
            options
        };
    }
};
